import { APP_TYPE } from '../constants'
import { getAppType } from './getAppType'

export const isKindOfApp = (): boolean =>
  [APP_TYPE.IOS_PWA, APP_TYPE.ANDROID_PWA, APP_TYPE.EMULATION, APP_TYPE.IOS_NATIVE, APP_TYPE.ANDROID_TWA].includes(
    getAppType(),
  )
